<template>
  <div class="md:p-10 lg:p-16 p-6 lg:pb-6 md:pb-6 pb-16 mx-auto bge3ceff-opa">
    <div class="lg:flex md:grid md:grid-cols-2 md-footerclass sm-footerclass">
      <div class="md:w-full lg:w-1/3 w-full md:px-4 lg:px-4 px-0">
        <div class="md:block lg:blok hidden">
          <img
            src="../../../assets/images/CSLogo.png"
            alt="Caregiver Saathi Logo"
            class="h-12"
          />
        </div>
        <div class="md:pt-8 lg:pt-8 pt-0">
          <p class="footertitle mb-6 fsize24-16">About Us</p>
          <span
            class="subtitle pt-6 pr-6 fsize18-14"
            @click="handleClick('about-us')"
            ><p>
              Caregiver Saathi™ is an initiative to support caregivers, to
              improve the quality of their lives, their well-being and those who
              they care for.
              <br />
              Caregiver Saathi Foundation is a Section 8 company with 12A
              registration and 80G certification working towards sustainable
              development goals.
            </p>

            <span
              class="block cursor-pointer text4F0A4B hover:underline font-bold fsize18-14"
              @click="readmore = !readmore"
            >
              {{ readmore ? " Read less" : " Read more" }}
            </span>
          </span>
        </div>
        <div class="md:pt-8 lg:pt-8 pt-4">
          <p class="fsize18-16 text-black font-semibold">Contact Us</p>
          <div class="flex mob-wrap pt-2 items-center">
            <!-- <feather-icon
              icon="PhoneIcon"
              class="pr-2 ftr-icon1"
            ></feather-icon> -->
            <div class="flex items-center lg:mr-8 md:mr-8 lg:mb-0 md:mb-0 mb-4">
              <img
                src="../../../assets/images/ftr-call.svg"
                alt=""
                class="ftr-icon1 pr-2"
              />
              <img
                src="../../../assets/images/logo/whatsapp.svg"
                alt=""
                class="ftr-icon1 pr-2"
              />
              <a
                class="fsize14px clr777 pr-6 fsize18-14 whitespacenowrap"
                href="tel:+919326161735"
                >+91-932-6161-735</a
              >
            </div>
            <div class="flex items-center">
              <img
                src="../../../assets/images/ftr-mail.svg"
                alt=""
                class="ftr-icon1 pr-2"
              />
              <a
                class="fsize14px break-word clr777 pr-6 whitespacenowrap fsize18-14"
                href="mailto:info@caregiversaathi.co.in"
                >info@caregiversaathi.co.in</a
              >
            </div>
          </div>
        </div>
        <div class="py-8 block md:hidden lg:hidden items-center">
          <p class="footertitle fsize24-16">Follow Us</p>
          <div class="pl-8 flex">
            <div class="pl-1">
              <a
                target="_blank"
                href="https://www.youtube.com/caregiversaathi"
                class="hover:text-primary hover:cursor-pointer flex"
              >
                <feather-icon
                  icon="YoutubeIcon"
                  class="pr-2 items-center cust-ht-ftr-icon"
                ></feather-icon>
              </a>
            </div>
            <div>
              <a
                target="_blank"
                href="https://www.facebook.com/caregiversaathi"
                class="hover:text-primary hover:cursor-pointer flex"
              >
                <feather-icon
                  icon="HeartIcon"
                  class="pr-2 items-center cust-ht-ftr-icon"
                ></feather-icon>
              </a>
            </div>
            <div>
              <a
                target="_blank"
                href="https://twitter.com/caregiversaathi"
                class="hover:text-primary hover:cursor-pointer flex"
              >
                <feather-icon
                  icon="TwitterIcon"
                  class="pr-2 items-center cust-ht-ftr-icon"
                ></feather-icon>
              </a>
            </div>
            <div>
              <a
                target="_blank"
                href="https://www.linkedin.com/company/caregiver-saathi"
                class="hover:text-primary hover:cursor-pointer flex"
              >
                <feather-icon
                  icon="LinkedinIcon"
                  class="pr-2 items-center cust-ht-ftr-icon"
                ></feather-icon>
              </a>
            </div>
            <div>
              <a
                target="_blank"
                href="https://www.instagram.com/caregiversaathi/"
                class="hover:text-primary hover:cursor-pointer flex"
              >
                <feather-icon
                  icon="InstagramIcon"
                  class="pr-2 items-center cust-ht-ftr-icon"
                ></feather-icon>
              </a>
            </div>
            <div>
              <a
                target="_blank"
                href="https://medium.com/@caregiversaathi"
                class="hover:text-primary hover:cursor-pointer flex"
              >
                <feather-icon
                  icon="GlobeIcon"
                  class="pr-2 items-center cust-ht-ftr-icon"
                ></feather-icon>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div
        class="w15perc md:w-full px-4 md:block lg:blok hidden lg:pt-0 md:pt-20"
      >
        <p class="footertitle fsize24-16">Services</p>
        <div class="pt-8">
          <ul>
            <li
              class="pt-4 font-normal subtitle cursor-pointer cust-hov-primary"
              @click="handleClick('caregiver')"
            >
              Caregiver
            </li>
            <li
              class="pt-4 font-normal subtitle cursor-pointer cust-hov-primary"
              @click="handleClick('wellwisher')"
            >
              Well-wisher
            </li>
            <li
              class="pt-4 font-normal subtitle cursor-pointer cust-hov-primary"
              @click="handleClick('hcp')"
            >
              Healthcare Professional
            </li>
            <li
              class="pt-4 font-normal subtitle cursor-pointer cust-hov-primary"
              @click="handleClick('corporate')"
            >
              Corporate
            </li>
            <li
              class="pt-4 font-normal subtitle cursor-pointer cust-hov-primary"
              @click="handleClick('careers')"
            >
              Careers
            </li>
          </ul>
        </div>
      </div>
      <div
        class="w15perc md:w-full px-4 md:block lg:block hidden lg:pt-0 md:pt-4"
      >
        <p class="footertitle fsize24-16">Follow Us</p>
        <div class="pt-8">
          <ul>
            <li class="pt-4 flex">
              <a
                target="_blank"
                href="https://www.youtube.com/c/CaregiverSaathi"
                class="hover:text-primary hover:cursor-pointer flex"
              >
                <feather-icon
                  icon="YoutubeIcon"
                  class="pr-2 items-center fsiz30px"
                ></feather-icon>
                <span class="subtitle">Youtube</span>
              </a>
            </li>
            <li class="pt-4 flex">
              <a
                target="_blank"
                href="https://www.facebook.com/caregiversaathi"
                class="hover:text-primary hover:cursor-pointer flex"
              >
                <feather-icon
                  icon="FacebookIcon"
                  class="pr-2 items-center"
                ></feather-icon>
                <span class="subtitle">Facebook</span>
              </a>
            </li>
            <li class="pt-4 flex">
              <a
                target="_blank"
                href="https://www.instagram.com/caregiversaathi/"
                class="hover:text-primary hover:cursor-pointer flex"
              >
                <feather-icon
                  icon="InstagramIcon"
                  class="pr-2 items-center"
                ></feather-icon>
                <span class="subtitle">Instagram</span>
              </a>
            </li>
            <li class="pt-4 flex">
              <a
                target="_blank"
                href="https://twitter.com/caregiversaathi"
                class="hover:text-primary hover:cursor-pointer flex"
              >
                <feather-icon
                  icon="TwitterIcon"
                  class="pr-2 items-center"
                ></feather-icon>
                <span class="subtitle">Twitter</span>
              </a>
            </li>

            <li class="pt-4 flex">
              <a
                target="_blank"
                href="https://www.linkedin.com/company/caregiver-saathi"
                class="hover:text-primary hover:cursor-pointer flex"
              >
                <feather-icon
                  icon="LinkedinIcon"
                  class="pr-2 items-center"
                ></feather-icon>
                <span class="subtitle">Linkedin </span></a
              >
            </li>
            <li class="pt-4 flex">
              <a
                target="_blank"
                href="https://medium.com/@caregiversaathi"
                class="hover:text-primary hover:cursor-pointer flex"
              >
                <feather-icon
                  icon="GlobeIcon"
                  class="pr-2 items-center"
                ></feather-icon>
                <span class="subtitle">Medium </span></a
              >
            </li>
          </ul>
        </div>
      </div>
      <div class="w37perc md:w-full md:px-4 lg:px-4 px-0 lg:pt-0 md:pt-4">
        <div class="">
          <p class="footertitle fsize24-16">Get All the Latest News</p>
          <div class="lg:pt-8 md:pt-8 pt-4">
            <p class="subtitle pr-6 fsize18-14">
              Join our mailing list to receive updates on upcoming events,
              services, offers and much more.
            </p>
          </div>
          <div class="lg:pt-10 md:pt-10 pt-4">
            <p class="fsize18 text333333 font-semibold">E-mail</p>
            <div class="pt-2 lg:w-5/6 md:w-5/6 relative">
              <validation-observer
                v-slot="{ handleSubmit }"
                ref="formValidator"
              >
                <b-form
                  role="form"
                  @submit.prevent="handleSubmit(handleSubscribe)"
                >
                  <base-input
                    placeholder="E.g. johndoe@abc.com"
                    class="cust-rounded-full"
                    name="Email"
                    v-model="email"
                    :rules="{ required: true, email: true }"
                  ></base-input>

                  <b-button
                    variant="outline-primary"
                    class="rounded-full ml-2 bg-white Subscribe-fotter-btn"
                    type="submit"
                    >Sign Up</b-button
                  >
                </b-form>
              </validation-observer>
            </div>
          </div>
        </div>
        <div class="md:py-12 lg:py-12 py-6">
          <div
            class="md:w-4/6 lg:w-4/6 w-full bg-white p-4 border-2 border-primary rounded-xl"
          >
            <p class="font-bold text-base text-primary">Helpline Number</p>
            <a
              class="pt-2 font-bold text-base text-black"
              href="tel:+91-932-6161-735"
            >
              +91-932-6161-735 </a
            ><br />
            <!-- <a
              class="pt-2 font-bold text-base text-black"
              href="tel:+91-22-2849-1565"
            >
              +91-22-2849-1565
            </a> -->
          </div>
        </div>
      </div>
    </div>
    <div class="lg:flex md:flex mt-4">
      <div
        class="md:w-full lg:w-1/4 w-full md:px-4 lg:px-4 px-0 lg:pt-0 md:pt-0 pt-4"
      >
        <p class="fsize15px cursor-default opacity-75">
          Copyright © 2022. @Caregiver Saathi
        </p>
      </div>
      <div class="w15perc md:px-4 lg:px-4 px-0 lg:pt-0 md:pt-0 pt-4">
        <p class="fsize15px cursor-pointer" @click="handleprivacy('terms')">
          Terms & Conditions
        </p>
      </div>
      <div class="w15perc md:px-4 lg:px-4 px-0 lg:pt-0 md:pt-0 pt-4">
        <p class="fsize15px cursor-pointer" @click="handleprivacy('privacy')">
          Privacy Policy
        </p>
      </div>
      <!-- <div
        class="md:w-1/3 lg:w-1/3 w-full md:px-4 lg:px-4 px-0 lg:pt-0 md:pt-0 pt-4"
      >
        <p class="fsize15px cursor-default opacity-75">
          Copyright © 2022. @Caregiver Saathi
        </p>
      </div> -->
    </div>
  </div>
</template>
<style>
.cust-rounded-full input {
  border-radius: 999px;
}
.ftr-icon1 > .feather {
  width: 13.36px;
  height: 17.51px;
}
.ftr-icon2 > .feather {
  width: 20px;
  height: 14px;
}
.cust-ht-ftr-icon > .feather {
  height: 20px;
}
</style>
<script>
import { gmailUserInfo } from "../../../helper/google";
import { mapState } from "vuex";

export default {
  data() {
    return {
      readmore: false,
      email: "",
    };
  },
  methods: {
    async handleSubscribe() {
      const payload = {
        email: this.email,
      };

      let loader = this.$loading();
      try {
        await this.$store.dispatch("newsletter/subscribeToNewsletter", payload);
        this.$swal("", "Thank you for subscribing", "success").then(() => {
          this.email = "";
          this.$refs.formValidator.reset();
        });
        loader.close();
      } catch (error) {
        this.$swal("", "Please add a valid email address", "error");
        loader.close();
      }
    },
    handleprivacy(name) {
      this.$router.push({ name: name });
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
    // handleClick(name) {
    //   this.$router.push({ name: name });
    // },
    async getToken(code) {
      try {
        let data = await this.$store.dispatch("google/getToken", {
          redirectURL: this.$homeAuth,
          code: code,
        });
        if (data.code === 200) {
          this.$store.commit("google/SET_GOOGLE_AUTH", {
            access_token: data.data,
            scope: decodeURIComponent(this.$route.query.scope),
          });
        }
        return data.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getTokenLinkedin(code) {
      try {
        let data = await this.$store.dispatch("linkedin/getToken", {
          redirectURL: this.$homeAuth,
          code: code,
        });
        return data.data;
      } catch (error) {
        console.log(error);
      }
    },
    // async signUpAction() {
    //   if (this.loginAction === "signUp") {
    //     let access_token = await this.getToken(
    //       decodeURIComponent(this.$route.query.code)
    //     );
    //     let userInfo = await gmailUserInfo(access_token);
    //     try {
    //       let payload = {
    //         firstname: userInfo.data.given_name || "",
    //         lastname: userInfo.data.family_name || "",
    //         email: userInfo.data.email || "",
    //         // scopes: auth.scope || "",
    //         // gender: data.genders[0].value,
    //         // dob: new Date(
    //         //   data.birthdays[0].date.year,
    //         //   data.birthday[0].date.month - 1,
    //         //   data.birthdays[0].date.day
    //         // ),
    //       };
    //       const data = await this.$store.dispatch(
    //         "auth/signUpWithGoogle",
    //         payload
    //       );
    //       if (data.code == 200) {
    //         // this.handleClose();

    //         this.$swal.fire({
    //           text: "Registered Successfully",
    //           icon: "success",
    //           confirmButtonText: "Okay",
    //           confirmButtonColor: "#830c81",
    //           showCancelButton: false,
    //         });
    //       }
    //     } catch (error) {
    //       console.log(error);
    //       if (error.response.status) {
    //         this.$swal.fire({
    //           // title: "Error",

    //           text: error.response.data.message,

    //           icon: "warning",
    //           confirmButtonColor: "#830c81",
    //           showCancelButton: false,
    //           showCloseButton: true,
    //         });
    //       }
    //     }
    //   } else if (this.loginAction === "login") {
    //     let access_token = await this.getToken(
    //       decodeURIComponent(this.$route.query.code)
    //     );
    //     let email = await gmailUserInfo(access_token);
    //     let payload = {
    //       email: email.data.email,
    //     };
    //     // console.log(payload);
    //     let loader = this.$loading();

    //     try {
    //       const data = await this.$store.dispatch(
    //         "auth/signUpWithGoogle",
    //         payload
    //       );
    //       if (data.code === 200) {
    //         loader.close();
    //       }
    //     } catch (error) {
    //       console.log(error);
    //       loader.close();
    //       if (error.response.status) {
    //         this.$swal.fire({
    //           // title: "Error",

    //           text: error.response.data.message,

    //           icon: "warning",
    //           confirmButtonColor: "#830c81",
    //           showCancelButton: false,
    //           showCloseButton: true,
    //         });
    //       }
    //     }
    //   }
    // },
    async signUpAction() {
      let access_token = await this.getToken(
        decodeURIComponent(this.$route.query.code)
      );
      let userInfo = await gmailUserInfo(access_token);
      try {
        let payload = {
          firstname: userInfo.data.given_name || "",
          lastname: userInfo.data.family_name || "",
          email: userInfo.data.email || "",
          loginAction: this.loginAction,
          // scopes: auth.scope || "",
          // gender: data.genders[0].value,
          // dob: new Date(
          //   data.birthdays[0].date.year,
          //   data.birthday[0].date.month - 1,
          //   data.birthdays[0].date.day
          // ),
        };

        const { data } = await this.$store.dispatch(
          "auth/signUpWithGoogle",
          payload
        );
        if (data) {
          this.$store.commit("auth/userData", data.user);

          const data1 = await this.$store.dispatch("eLearning/getProfile", {
            userId: data.user._id,
          });
          if (data.user.role == "volunteer") {
            const data2 = await this.$store.dispatch(
              "respitecare/get_volunteerbyuserid",
              {
                volunteerId: data.user._id,
              }
            );
          }
        }

        if (data.register === true) {
          // this.handleClose();

          this.$swal.fire({
            title: "Registered Successfully",
            html: "<p style='text-align:center'>Discover more features! Check out our plans to find the best fit for you</p>",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
        if (!data.user.isPasswordSet) {
          this.$swal
            .fire({
              text: "Please generate password for security reasons!",
              icon: "info",
              confirmButtonColor: "#830c81",
              showCancelButton: false,
              showCloseButton: true,
            })
            .then((result) => {
              if (result.value) {
                this.$router.push({
                  name: "forgot-password",
                  query: { setPassword: true },
                });
              }
            });
        }

        // if (data) {
        //   this.$store.commit("auth/userData", data.user);

        //   const data1 = await this.$store.dispatch("eLearning/getProfile", {
        //     userId: data.user._id,
        //   });
        //   if (data.user.role == "volunteer") {
        //     const data2 = await this.$store.dispatch(
        //       "respitecare/get_volunteerbyuserid",
        //       {
        //         volunteerId: data.user._id,
        //       }
        //     );
        //   }
        // }

        // if (data.register === true) {
        //   // this.handleClose();

        //   this.$swal.fire({
        //     text: "Registered Successfully",
        //     icon: "success",
        //     confirmButtonText: "Okay",
        //     confirmButtonColor: "#830c81",
        //     showCancelButton: false,
        //   });
        // }
      } catch (error) {
        console.log(error);
        if (error.response.status) {
          this.$swal
            .fire({
              // title: "Error",

              text: error.response.data.message,

              icon: "warning",
              confirmButtonColor: "#830c81",
              showCancelButton: false,
              showCloseButton: true,
            })
            .then((result) => {
              if (
                error.response.data.message.includes(
                  "Your account is in-active"
                )
              ) {
                this.$router.push({ name: "account-active" });
                console.log("Move to activate account page");
              }
            });
        }
      }
    },
    async signUpActionLinkedin() {
      let { access_token } = await this.getTokenLinkedin(
        decodeURIComponent(this.$route.query.code)
      );

      try {
        let userInfo = await this.$store.dispatch("linkedin/getUserInfo", {
          access_token: access_token,
        });
        // console.log(userInfo);
        let payload = {
          firstname: userInfo.firstName,
          lastname: userInfo.lastName,
          email: userInfo.email,
        };
        const { data } = await this.$store.dispatch(
          "auth/signUpWithLinkedin",
          payload
        );
        // console.log(data);
        if (data) {
          this.$store.commit("auth/userData", data.user);

          const data1 = await this.$store.dispatch("eLearning/getProfile", {
            userId: data.user._id,
          });
          if (data.user.role == "volunteer") {
            const data2 = await this.$store.dispatch(
              "respitecare/get_volunteerbyuserid",
              {
                volunteerId: data.user._id,
              }
            );
          }
        }

        if (data.register === true) {
          // this.handleClose();

          this.$swal.fire({
            title: "Registered Successfully",
            html: "<p style='text-align:center'>Discover more features! Check out our plans to find the best fit for you</p>",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
      } catch (error) {
        console.log(error);
        if (error.response.status) {
          this.$swal.fire({
            // title: "Error",

            text: error.response.data.message,

            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
            showCloseButton: true,
          });
        }
      }
    },
    async signUpActionWhatsapp(firstName, mobile) {
      try {
        // let userInfo = await this.$store.dispatch("whatsapp/getUserInfo", {
        //   waId: waId,
        // });
        // console.log("WHATSAPP USERINFO:", userInfo);
        let payload = {
          firstname: firstName,
          mobile: mobile,
        };
        const { data } = await this.$store.dispatch(
          "auth/signUpWithWhatsapp",
          payload
        );
        // console.log("WHATSAPP DATA:", data);
        if (data) {
          // console.log("INSIDE DATA");
          this.$store.commit("auth/userData", data.user);
          const data1 = await this.$store.dispatch("eLearning/getProfile", {
            userId: data.user._id,
          });
          if (data.user.role == "volunteer") {
            const data2 = await this.$store.dispatch(
              "respitecare/get_volunteerbyuserid",
              {
                volunteerId: data.user._id,
              }
            );
          }
        }
        if (data.register === true) {
          // this.handleClose();
          this.$swal.fire({
            title: "Registered Successfully",
            html: "<p style='text-align:center'>Discover more features! Check out our plans to find the best fit for you</p>",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
      } catch (error) {
        console.log(error);
        if (error.response.status) {
          this.$swal.fire({
            // title: "Error",
            text: error.response.data.message,
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
            showCloseButton: true,
          });
        }
      }
    },
  },
  async mounted() {
    try {
      if (this.$route.query.code && window.location.href.includes("/home")) {
        if (this.signinWith === "google") {
          await this.signUpAction();
          this.$store.commit("auth/signinWith", "");
        } else if (this.signinWith === "linkedin") {
          await this.signUpActionLinkedin();
          this.$store.commit("auth/signinWith", "");
        }
      }

      // ****************
      // window.otpless = async (otplessUser) => {
      //   const waName = otplessUser.waName;
      //   const waNumber = otplessUser.waNumber;
      //   // console.log("WHATSAPP USERDATA MOUNTED", waName, waNumber);
      //   if (waName && waNumber) {
      //     await this.signUpActionWhatsapp(waName, waNumber);
      //     this.$router.push({ name: "home" });
      //   }
      // };
      // ****************
      // else if (this.signinWith === "whatsapp") {
      // const waId = window.otplessWaId();
      // const waId = localStorage.getItem("otpless_waId");
      // console.log("FOOTER WAID:", waId);
      // await this.signUpActionWhatsapp(waId);
      // this.$store.commit("auth/signinWith", "");
      // }
    } catch (error) {
      console.log(error);
    }
  },
  computed: {
    ...mapState("auth", ["loginAction"]),
    ...mapState("auth", ["signinWith"]),
  },
};
</script>
<style scoped>
.cust-hov-primary:hover {
  color: #430940;
}
.bge3ceff-opa {
  background-color: #cbedf2;
}
</style>
